<template>
    <div id="users-list">
        <!-- <div v-if="message" class="message">
             {{message}}
         </div>-->
        <Message :message="message" :type="type" v-if="message !== ''"></Message>
        <h2 class="title">{{$t('users.title')}}</h2>
        <div class="content">
            <div class="controls" v-if="loaded">
                <div class="add-link" v-if="$store.getters.isAdmin">
                    <router-link :to="{name: 'register-user', params:{user: {}}}">
                        <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
                        {{$t('users.add')}}
                    </router-link>
                </div>
                <input :placeholder="$t('users.search')" type="text" v-model="search"/>
            </div>
            <div class="paging" v-if="users.length > size && !displayModal">
                <pager :init-page="pageNumber+1"
                       :show-jump="false"
                       :text-next="$t('pager.nextPage')"
                       :text-previous="$t('pager.previousPage')"
                       :total-page="pageCount"
                       @go-page="goPage"
                >
                </pager>
            </div>
            <div class="table-container" v-if="!displayModal">
                <div class="table">
                    <div class="tr" v-if="loaded">
                        <span class="td">{{$t('general.number-order')}}</span>
                        <span @click="sort('username')" class="td"><div class="sortable-column">
                            {{$t('users.login')}}
                            <div class="sort-direction">
                            <font-awesome-icon icon="sort" v-if="currentSort !== 'username'"></font-awesome-icon><div
                                    v-else>
                            <font-awesome-icon icon="caret-down" v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                            </div>
                        </div>
                        </div>
                        </span>
                        <span @click="sort('secondName')" class="td"><div class="sortable-column">
                            {{$t('users.nameAndSurname')}}
                            <div class="sort-direction">
                            <font-awesome-icon icon="sort" v-if="currentSort !== 'secondName'"></font-awesome-icon><div
                                    v-else>
                            <font-awesome-icon icon="caret-down" v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                        </div></div></div></span>
                        <span class="td">{{$t('users.role')}}</span>
                        <span class="td">{{$t('users.groups')}}</span>
                        <span @click="sort('status')" class="td"><div class="sortable-column">
                            {{$t('users.status')}}
                            <div class="sort-direction">
                            <font-awesome-icon icon="sort" v-if="currentSort !== 'status'"></font-awesome-icon><div
                                    v-else>
                            <font-awesome-icon icon="caret-down" v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                            </div></div></div></span>
                        <span class="td" v-if="$store.getters.isAdmin">{{$t('general.operations')}}</span>
                    </div>
                    <User :index="index+1" :key="user.id" :user="user" v-for="(user,index) in paginatedUsers"
                          @removal="removeUser" v-if="loaded"></User>
                    <Preloader v-if="!loaded"></Preloader>

                </div>

            </div>
            <div class="paging" v-if="users.length > size && !displayModal">
                <pager :init-page="pageNumber+1"
                       :show-jump="false"
                       :text-next="$t('pager.nextPage')"
                       :text-previous="$t('pager.previousPage')"
                       :total-page="pageCount"
                       @go-page="goPage"
                >
                </pager>
            </div>

            <div class="modal" v-if="displayModal && loaded">
                <p>{{$t('users.removal.firstPart')}}: <span
                        style="font-weight: bold;"> {{userToRemove.username}}</span> <span> {{$t('users.removal.lastPart')}}</span>
                </p>
                <div class="operations">
                    <button class="save" v-on:click="handleRemoval">{{$t('users.removal.yes')}}</button>
                    <button class="cancel" v-on:click="cancel">{{$t('users.removal.no')}}</button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import pager from 'vue-simple-pager';
import User from '@/components/user/User.vue';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Preloader from '@/components/helpers/Preloader.vue';
import { UserError } from '@/api/user/erros';
import Message from '@/components/helpers/Message.vue';

const UserRepository = RepositoryFactory.get('users');

export default {
  name: 'UsersList',
  data() {
    return {
      users: [],
      search: '',
      loaded: false,
      size: 10,
      pageNumber: 0,
      currentSort: 'username',
      currentSortDir: 'asc',
      displayModal: false,
      userToRemove: {},
      message: '',
      type: 'info',

    };
  },
  components: {
    Preloader,
    User,
    Message,
    pager,
  },
  mounted() {
    const { token } = this.$store.getters;
    UserRepository.getUsersList(token)
      .then((response) => {
        this.users = response;
        this.loaded = true;
        // console.log(response);
      });
    // this.users = UserRepository.getUsersListup();
    // this.loaded = true;
  },
  computed: {
    filteredUsers() {
      return this.sortedUsers.filter(user => user.username.toLowerCase().includes((this.search.toLowerCase()))
        || user.firstName.toLowerCase().includes((this.search.toLowerCase()))
        || user.secondName.toLowerCase().includes((this.search.toLowerCase())));
    },
    paginatedUsers() {
      const start = this.pageNumber * this.size;
      const end = start + this.size;
      return this.filteredUsers.slice(start, end);
    },
    pageCount() {
      const l = this.filteredUsers.length;
      const s = this.size;
      return Math.ceil(l / s);
    },
    sortedUsers() {
      return this.users.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
  },
  methods: {
    goPage(data) {
      this.pageNumber = data.page - 1;
    },
    nextPage() {
      if (this.pageNumber + 1 > this.pageCount) {
        window.scroll(0, 0);
      } else {
        this.pageNumber++;
        window.scroll(0, 0);
      }
    },
    prevPage() {
      this.pageNumber--;
      window.scroll(0, 0);
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    removeUser(user) {
      this.userToRemove = user;
      this.displayModal = true;
    },
    handleRemoval() {
      const { token } = this.$store.getters;
      this.loaded = false;
      UserRepository.deleteUser(this.userToRemove.id, token)
        .then(() => {
          this.displayModal = false;
          UserRepository.getUsersList(token)
            .then((response) => {
              this.users = response;
              this.loaded = true;
              this.message = 'Użytkownik usunięty';
              this.type = 'info';
              this.userToRemove = {};
            });
        })
        .catch((e) => {
          if (e instanceof UserError) {
            this.message = 'Wystąpił niespodziewany błąd, spróbuj ponownie później';
            this.type = 'error';
            this.displayModal = false;
            this.loaded = true;
          }
        });
    },
    cancel() {
      this.userToRemove = {};
      this.displayModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
    #users-list {
        /*width: 1510px;*/
        margin: 0 auto;
    }

    .sort-direction {
        margin-left: 10px;
    }

    h2 {
        font-size: rem(30px);
        font-weight: 800;
        text-align: left;
        // color: $baseTextColor;
    }

    DIV.table {
        display: table;
        background: $white;
        box-shadow: 0 5px 6px $baseShadow;
        padding: 46px 36px;
        border-radius: 5px;
        margin: 0 auto;
        width: 100%;
        box-sizing: border-box;
        border-collapse: separate;
        // color: $baseTextColor;
    }

    .modal {
        background: $white;
        box-shadow: 0 5px 6px $baseShadow;
        padding: 46px 36px;
        border-radius: 5px;
        margin: 0 auto;
        width: 100%;
        box-sizing: border-box;
        // color: $baseTextColor;

        .operations {
            button {
                margin: 15px 25px;
            }
        }
    }

    FORM.tr, DIV.tr {
        display: table-row;
    }

    div.tr {
        border: none;

        &:first-child {
            font-weight: bold;

            > .td {
                border-bottom: 1px solid $border-blue;
                padding-bottom: 16px;
                line-height: rem(18px);
            }
        }

        > .td {
            border-top: none;
            font-size: rem(14px);
            line-height: rem(19px);
        }
    }

    SPAN.td {
        display: table-cell;
        border: none;

        &:first-child {
            border-left: none;
        }

        &:last-child {
            border-right: none;

        }
    }

    .controls {
        margin-bottom: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        input {
            border: 1px solid $border-gray;
            width: 611px;
            box-sizing: border-box;
            padding: 20px 40px;
            border-radius: 5px;

        }


        .add-link {
            font-size: rem(18px);
            color: $peacock-blue;
            font-weight: 900;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: left;

            svg {
                margin-right: 15px;
            }

            a {
                margin-left: 17px;
                text-decoration: none;
                color: $peacock-blue;

                &:active, &:hover, &:visited {
                    color: $peacock-blue;
                }
            }

        }
    }

    .sortable-column {
        display: flex;
        justify-content: center;
    }

    button {
        border: none;
        background: none;
        cursor: pointer;
        color: $peacock-blue;
        font-size: rem(18px);
        font-weight: bold;

        &.cancel, &.save {

            color: white;
            font-size: rem(18px);
            font-weight: bold;
            padding: 12px 50px;
            border-radius: 30px;
            transition: 300ms all ease-in;

        }

        &.save {
            background: $peacock-blue;
            border: 1px solid $peacock-blue;

            &:hover {
                color: $peacock-blue;
                background: white;
            }
        }

        &.cancel {
            background-color: $marine-blue;
            border: 1px solid $marine-blue;

            &:hover {
                color: $marine-blue;
                background: white;
            }
        }
    }

    .table-container {
        overflow: visible;
    }

    .paging {
        margin-bottom: 35px;

        button {
            margin: 0 15px;
        }
    }
</style>
